import { configureStore } from "@reduxjs/toolkit";
import errorModalReducer from "./slices/errorModalSlice";
import loadingReducer from "./slices/loadingSlice";

const store = configureStore({
  reducer: {
    errorModal: errorModalReducer,
    loading: loadingReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
